/**
 * EMR Data Thunks
 * Async actions for fetching and saving summary section EMR form data
 */

import { createAsyncThunk } from '@reduxjs/toolkit';
import * as emrDataApi from '../api/emrDataApi';

/**
 * Fetch all EMR data for a patient (health concerns, diagnoses, etc.)
 */
export const fetchEMRData = createAsyncThunk(
  'emr/fetchEMRData',
  async (patientId, { rejectWithValue }) => {
    try {
      const data = await emrDataApi.fetchEMRData(patientId);
      return { patientId, data };
    } catch (error) {
      console.error('Error fetching EMR data:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  },
  {
    condition: (patientId, { getState }) => {
      const state = getState();
      const isLoading = state.emr?.emrDataLoading?.[patientId];
      const hasData = !!state.emr?.emrDataByPatient?.[patientId];
      // Skip if already loading or already have data for this patient
      return !isLoading && !hasData;
    }
  }
);

/**
 * Save EMR form data — only pass the fields being updated
 * e.g. { healthConcerns: "..." } or { diagnoses: "..." }
 */
export const saveEMRData = createAsyncThunk(
  'emr/saveEMRData',
  async ({ patientId, data }, { rejectWithValue }) => {
    try {
      await emrDataApi.saveEMRData(patientId, data);
      return { patientId, data };
    } catch (error) {
      console.error('Error saving EMR data:', error);
      return rejectWithValue(error.response?.data || error.message);
    }
  }
);
